const TRANSACTION_TYPES = Object.freeze({
  CW20_RECEIVED: 'cw20-received',
  CW20_SENT: 'cw20-sent',
  RECEIVED: 'received',
  SENT: 'sent',
});

const EVENT_FILTERS = Object.freeze({
  [TRANSACTION_TYPES.CW20_RECEIVED]: 'wasm.to',
  [TRANSACTION_TYPES.CW20_SENT]: 'wasm.from',
  [TRANSACTION_TYPES.RECEIVED]: 'transfer.recipient',
  [TRANSACTION_TYPES.SENT]: 'transfer.sender',
});

export default Object.freeze({
  EVENT_FILTERS,
  TRANSACTIONS_NUMBER: 10,
  TRANSACTION_TYPES,
});
